import { defineComponent as o, inject as r, h as t } from "vue";
import { menuInjectionKey as u } from "./ghl-ui.es1011.js";
const d = o({
  name: "MenuDivider",
  setup() {
    const e = r(u), {
      mergedClsPrefixRef: n,
      isHorizontalRef: i
    } = e;
    return () => i.value ? null : t("div", {
      class: `${n.value}-menu-divider`
    });
  }
});
export {
  d as default
};
